import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * Lightweight hook that returns total unique horse count from the DB.
 * Replaces the heavy useRecentRaceData approach on homepage.
 */
export const useHomepageHorseCount = () => {
  return useQuery({
    queryKey: ["homepage-horse-count"],
    queryFn: async () => {
      const { count, error } = await supabase
        .from("individual_horses")
        .select("id", { count: "exact", head: true });

      if (error) throw error;
      return count || 0;
    },
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  });
};
